import { getOrgMembersAction } from '../../../shared/organization/organizationActions';
import { useOrgUserStore } from '../../../shared/organization/orgUserStore';
import { useModalStore } from '../../../shared/store/uiStore';
import DiagramAIForm from './DiagramAIForm';
import DiagramForm from './DiagramForm';
import { DiagramFormUser } from './types';
import { DiagramModel } from '@diagram/model/diagram.model';

export const openDiagramFormModal = async (data?: DiagramModel) => {
  if (!data?.id) {
    useModalStore.getState().openModal({
      id: 'diagram-form-create-modal',
      title: 'Generate New Diagram',
      size: 'lg',
      content: <DiagramAIForm />,
      buttons: [
        {
          label: 'Generate Diagram',
          form: 'diagram-form',
          type: 'submit',
          variant: 'primary',
          showLoading: true,
        },
        {
          label: 'Cancel',
          onClick: () => {
            useModalStore.getState().closeModal();
          },
          type: 'button',
          variant: 'outline',
        },
      ],
    });
    return;
  }
  // If not creating a new diagram, fetch the existing diagram data
  await getOrgMembersAction();
  const items = useOrgUserStore.getState().items;

  const users = Object.entries(
    data?.users as Record<string, 'viewer' | 'editor'>,
  ).reduce((acc: DiagramFormUser[], [uid, role]: [string, string]) => {
    const user = Object.values(items).find((item) => item.uid === uid);
    if (user?.id) {
      acc.push({
        ...user,
        role: role as 'viewer' | 'editor',
        orgRole: user.role as 'viewer' | 'editor',
      });
    }
    return acc;
  }, []);

  const formData = {
    name: data?.name || '',
    description: data?.description || '',
    isPublic: data?.access === 'public',
    users: users || [],
  };

  useModalStore.getState().openModal({
    id: 'diagram-form-edit-modal',
    title: 'Edit Diagram',
    size: 'lg',
    content: <DiagramForm diagramData={formData} id={data.id} />,
    buttons: [
      {
        label: 'Save',
        form: 'diagram-form1',
        type: 'submit',
        variant: 'primary',
      },
      {
        label: 'Cancel',
        onClick: () => {
          useModalStore.getState().closeModal();
        },
        type: 'button',
        variant: 'outline',
      },
    ],
  });
};
